import { createContext, useContext, useMemo, useState } from 'react';
import PropTypes from 'prop-types';

const LoaderContext = createContext({});

export const LoaderProvider = ({ children }) => {
  // states
  const [isLoading, setIsLoading] = useState(false);

  // constants
  const values = useMemo(() => ({
    isLoading,
    setIsLoading,
  }), [isLoading]);

  return <LoaderContext.Provider value={values}>{children}</LoaderContext.Provider>;
};

export const useLoader = () => {
  const context = useContext(LoaderContext);
  if (context === undefined) {
    throw new Error('useLoader must be used within a LoaderProvider');
  }
  return context;
};

LoaderProvider.propTypes = {
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]).isRequired,
};

export default useLoader;
